import React, { Component } from "react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import Table from "../common/table";

class TagsTable extends Component {
  columns = [
    {
      path: "name",
      label: "Nombre",
      content: tag => <Link to={`/tags/${tag._id}`}>{tag.name}</Link>
    },
   
  ];

  deleteColumn = {
    key: "delete",
    content: tag => (
      <div>
      <button
        onClick={() => this.props.onDelete(tag)}
        className="btn btn-danger btn-sm ml-2"
      >
        Borrar
      </button>
      </div>
      
    )
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.isAdmin) this.columns.push(this.deleteColumn);
  }

  render() {
    const { tags, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={this.columns}
        data={tags}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default TagsTable;
